import React from 'react'
import InnerPopup from './InnerPopup'
import { withTranslation } from 'react-i18next'
import { IoIosInformationCircleOutline } from "react-icons/io";


const ConfirmDataBetDeskonPopup = (props) => {
    const { onClose, message } = props

    // const callProcessSubmit = () => {
    //     props.submitProcessOk();
    // }
    return (
        <div className="confirmation_modal">
            <InnerPopup onCloseModal={onClose}>
               
                <div className="betdiskon_poupcontent">
                <div className='confirm_img_conatiner'>
                <IoIosInformationCircleOutline />
                    </div>
                    <p>
                        Process Bet

                    </p>
                    <div className='bet_txt'>{message}</div>
                    <div className="confirm_poupcontent_btns">
                        <button className="btn" onClick={onClose}>
                            No
                        </button>
                        <button className="btn" >
                            Yes
                        </button>
                    </div>
                </div>
            </InnerPopup>
        </div>
    )
}

export default withTranslation()(ConfirmDataBetDeskonPopup)